<template>
  <div class="blog-container">
    <div class="blog-container--title">
      <div class="tip">药师博客</div>
      <div class="look-all">
        <router-link to="/blogHome" tag="span">查看全部</router-link>
        <Icon type="android-arrow-dropright-circle" class="dropright"></Icon>
      </div>
    </div>
    <div class="blog-container--content">
      <div
        class="blog-left"
        @mouseenter="on_top_enter"
        @mouseleave="on_top_leave"
      >
        <swiper
          class="swiper-box"
          :options="swiperOption"
          ref="mySwiper"
          v-if="blogList.Banner && blogList.Banner.length > 0"
        >
          <swiper-slide v-for="item of blogList.Banner" :key="item.id">
            <div class="banner-box" @click="goDetail(item.id)">
              <img :src="item.image_input" alt="" />
              <div class="title">{{ item.title }}</div>
            </div>
            <div class="des">
              {{ item.synopsis }}
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="blog-right">
        <div class="blog-right--title">
          <div class="tip">药师博客</div>
          <div
            class="menu"
            v-for="(item, index) of blogList.cate"
            :key="item.id"
            @click="changeIndex(index)"
            :class="active === index ? 'active' : ''"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="blog-right--content">
          <div class="des">
            <div class="item" v-for="item of productList" :key="item.id">
              <div class="item-left">
                <img :src="item.image_input[0]" alt="" />
              </div>
              <div class="item-right">
                <div class="item-right--title" @click="goDetail(item.id)">
                  {{ item.title }}
                </div>
                <div class="item-right--author">
                  药师作者：{{ item.author }}
                </div>
                <div class="item-right--des">
                  {{ item.synopsis }}
                </div>
              </div>
            </div>
          </div>
          <div class="home-art">
            <div
              class="conlist"
              v-for="item of productList.slice(2, 5)"
              :key="item.id"
            >
              {{ item.title }}
            </div>
            <div class="conlist more" v-if="productList.length > 5">
              更多<Icon type="arrow-right-b" class="right-b"></Icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DrugBlog",
  props: ["blogList"],
  data() {
    return {
      swiperOption: {
        // 循环
        loop: true,
        // 每张播放时长3秒，自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplayDisableOnInteraction: false,
        // 滑动速度
        speed: 1000,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true // 修改swiper的父元素时，自动初始化swiper
      },
      active: 0,
      productList: []
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  watch: {
    blogList() {
      this.getProductList(0);
    }
  },
  methods: {
    on_top_enter() {
      this.swiper.autoplay.stop();
    },
    on_top_leave() {
      this.swiper.autoplay.start();
    },
    changeIndex(index) {
      this.active = index;
      this.getProductList(index);
    },
    getProductList(index) {
      if (this.blogList.list) {
        this.productList = this.blogList.list[index];
      }
    },
    goDetail(id) {
      this.$router.push("/articleDetail?id=" + id);
    }
  }
};
</script>

<style lang="stylus" scoped>
.blog-container
  width 1200px
  margin 0 auto
  padding-bottom 20px
  &--title
    height 60px
    line-height 60px
    border-bottom 2px solid #0e86ff
    display flex
    justify-content space-between
    font-family 'Microsoft yahei'
    .tip
      font-size 24px
      color #333
    .look-all
      font-size 16px
      position relative
      color #424242
      line-height 65px
      cursor pointer
      &:hover
        color #0e86ff
      .dropright
        margin-left 10px
        font-size 20px
        color #bbbbbb
        transform translateY(1px)
  &--content
    margin-top 20px
    display flex
    background #fff
    border 1px solid #e4e4e4
    .blog-left
      width 360px
      padding 15px
      border-right 1px solid #e4e4e4
      .swiper-box
        height 234px
        .banner-box
          position relative
          width 100%
          height 190px
          cursor pointer
          img
            width 100%
            height 100%
          .title
            width 100%
            height 24px
            line-height 24px
            text-align center
            position absolute
            bottom 0
            background rgba(0, 0, 0, 0.4)
            color #fff
            z-index 11
        .des
          margin-top 10px
          display -webkit-box !important
          overflow hidden
          text-overflow ellipsis
          word-break break-all
          -webkit-box-orient vertical
          -webkit-line-clamp 2
    .blog-right
      flex 1
      padding 20px 30px 0
      &--title
        height 34px
        line-height 34px
        border-bottom 1px solid #e4e4e4
        display flex
        .tip
          width 80px
          font-size 18px
          margin-right 20px
        .menu
          padding 0 15px
          font-size 14px
          line-height 32px
          transform translateY(2px)
          cursor pointer
          &.active
            border 1px solid #e4e4e4
            border-bottom 2px solid #fff
            color #0e86ff
      &--content
        .des
          margin 25px 0
          display flex
          justify-content space-between
          .item
            width 48%
            height 80px
            display flex
            &-left
              width 120px
              margin-right 20px
              img
                width 100%
                height 100%
            &-right
              width 240px
              &--title
                cursor pointer
                width 240px
                white-space:nowrap;
                color #377bee
                font-size 14px
                overflow hidden
              &--author
                color #999999
              &--des
                margin-top 6px
                height 40px
                line-height 20px
                color #555
                display -webkit-box !important
                overflow hidden
                text-overflow ellipsis
                word-break break-all
                -webkit-box-orient vertical
                -webkit-line-clamp 2
        .home-art
          border-top 1px solid #e4e4e4
          padding 10px 0
          display flex
          flex-wrap wrap
          .conlist
            width 50%
            line-height 25px
            font-size 14pz
            color #333
          .more
            color #377bee
            cursor pointer
            .right-b
              margin-left 5px
              font-size 14px
              transform translateY(1px)
</style>
